/** Extract an invite code from a scanned QR payload (URL or raw code). */
export function parseInvitePayload(raw: string): string | null {
  const trimmed = raw.trim()
  if (!trimmed) return null

  try {
    const url = new URL(trimmed)
    const match = url.pathname.match(/\/invite\/([^/]+)/i)
    if (match?.[1]) {
      return decodeURIComponent(match[1]).trim().toUpperCase()
    }
  } catch {
    /* not a URL */
  }

  const code = trimmed.replace(/\s+/g, '').toUpperCase()
  if (/^[ABCDEFGHJKLMNPQRSTUVWXYZ23456789]{8,64}$/.test(code)) return code
  return null
}
